import AudioThumbnailButton from './component'
export default AudioThumbnailButton
